<template>
  <div class="content container p-0">
    <error-page v-if="error" :error="error" :status-code="statusCode"></error-page>
    <page-loader v-else></page-loader>
  </div>
</template>

<script>
import PageLoader from '@/components/Loading/PageLoader.vue'
import ErrorPage from '@/views/ErrorPage.vue'
import { ErrorHelper } from '@/helpers/ErrorHelper'
import { WebApi } from '@/services/WebApi'

export default {
  name: 'SlugRedirectorView',
  data () {
    return {
      error: '',
      statusCode: 500
    }
  },
  methods: {
    tryRedirect () {
      const self = this
      const { slug, feature, postId } = self.$route.params
      let path = 'go/' + encodeURIComponent(slug || '')
      if (feature) path += '/' + encodeURIComponent(feature)
      if (postId) path += '/' + encodeURIComponent(postId)
      WebApi.get(path)
        .then(response => { window.location.href = response.data.link })
        .catch(error => {
          self.statusCode = (error.response && error.response.status) || 500
          self.error = ErrorHelper.getError(error)
        })
    }
  },
  components: {
    'page-loader': PageLoader,
    'error-page': ErrorPage
  },
  created () {
    this.tryRedirect()
  }
}
</script>
